'use client';

import { CheckableElementProps } from '@/interfaces/basicForm';
import { checkedValue } from '@/utils/helper';
import { useEffect, useState } from 'react';
import { CDN } from '@/constants';
import { DynamicIcon } from '@/icons/DynamicIcon';

export const StyleCheckbox = ({ name, value, label, url, className = '', selectedValues, onChange, svgContentFromServer }: CheckableElementProps) => {
  const [checked, setChecked] = useState(false);
  const [svgContent, setSvgContent] = useState('');

  useEffect(() => {
    setChecked(checkedValue(selectedValues, value));
  }, [selectedValues, value]);

  useEffect(() => {
    if (url) {
      fetch(url.replace('https://storage.apex4u.com', CDN))
        .then(async (response) => response.text())
        .then((x) => {
          if (x) {
            setSvgContent(x);
          }
        });
    }
  }, [url]);

  return (
    <label
      className={`checkbox size-checkbox h-full w-full cursor-pointer flex-col rounded-[5px] border border-[#e5e5e5] hover:border-black ${
        checked ? 'checked bg-black text-white' : 'bg-transparent'
      } ${className}`}
    >
      <input
        type="checkbox"
        className="hidden"
        checked={checked}
        {...{ name, value }}
        onChange={(e) => {
          if (checked) {
            setChecked(false);
          } else {
            setChecked(true);
          }
          onChange?.();
        }}
      />
      {svgContent ? (
        <div className="flex aspect-video w-full flex-col items-center justify-center">
          <div className="mb-1.5 flex aspect-square w-1/3 items-center justify-center">
            {(() => {
              try {
                // Parse to extract viewBox, but extract innerHTML directly
                const parser = new DOMParser();
                const svgDoc = parser.parseFromString(svgContent, 'image/svg+xml');

                // Check for parsing errors
                const parserError = svgDoc.querySelector('parsererror');
                if (parserError) {
                  console.error('SVG parsing error:', parserError.textContent);
                  return null;
                }

                const svgElement = svgDoc.querySelector('svg');

                if (svgElement) {
                  const viewBox = svgElement.getAttribute('viewBox') || '0 0 230 150';
                  // Get innerHTML directly to preserve path attributes exactly
                  const innerHTML = svgElement.innerHTML || '';

                  if (!innerHTML) {
                    return null;
                  }

                  return (
                    <DynamicIcon className="aspect-square" viewBox={viewBox}>
                      <g dangerouslySetInnerHTML={{ __html: innerHTML }}></g>
                    </DynamicIcon>
                  );
                }
                return null;
              } catch (error) {
                console.error('Error parsing SVG content:', error);
                return null;
              }
            })()}
          </div>
          <span className="-mb-2 text-center">{label}</span>
        </div>
      ) : (
        <div className="aspect-video w-full animate-pulse bg-gray-200 dark:bg-gray-700"></div>
      )}
    </label>
  );
};
